import { Box, FormControl, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { PublicSelectProps } from "../../constants/types";
import { CLOUDN_COLORS, COLORS } from "../../constants/colors";

const PublicSelect = (props: PublicSelectProps) => {
  const [menus, setMenus] = useState<JSX.Element[]>([]);

  useEffect(() => {
    setMenus(
      props.items.map((data, index) => (
        <MenuItem key={index} value={data.value}>
          {data.label}
        </MenuItem>
      ))
    );
  }, [props.items]);

  console.warn = () => {};

  return (
    <StyledBox
      sx={{
        width: `${props.width}%`,
        height: `${props.height}%`,
        background: "white",
        margin: props.margin,
      }}
    >
      <FormControl fullWidth sx={{ height: "100%" }}>
        <Select
          style={{
            height: "100%",
            fontSize: "0.9vw",
            color: COLORS.fontColor,
          }}
          value={props.value}
          placeholder="전체"
          onChange={props.onChange}
        >
          {props.placeholder && (
            <MenuItem disabled value={"1"}>
              {props.placeholder}
            </MenuItem>
          )}
          {props.all && <MenuItem value={"all"}>전체</MenuItem>}
          {menus}
        </Select>
      </FormControl>
    </StyledBox>
  );
};

export default PublicSelect;

const StyledBox = styled(Box)`
  .MuiSvgIcon-root {
    color: ${CLOUDN_COLORS.logoSkyBlue};
    font-size: 1.2vw;
  }
`;
